import React from "react";
import { NavLink } from "react-router";

import { captureEvent } from "components/posthog/customEventCapture";
import { PrimaryArrowButton } from "components/button/Button";

import "./Link.scss";

type LinkPrimaryArrowProps = {
  to: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
};

type LinkProps = {
  to: string;
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  [key: string]: any;
};

export default function Link({ to, children, onClick, ...props }: LinkProps) {
  if (!to) {
    return <span {...props}>{children}</span>;
  }

  if (/^https?:\/\//.test(to)) {
    return (
      <a {...props} href={to} className="linkPrimary">
        {children}
      </a>
    );
  }

  return (
    <NavLink
      to={to}
      className="linkPrimary"
      onClick={(e) => {
        const captureEventContent =
          typeof children === "string" ? children : String(children);
        captureEvent(captureEventContent);

        if (onClick) {
          onClick(e);
        }
      }}
      {...props}
    >
      {children}
    </NavLink>
  );
}

export function LinkPrimaryArrow({
  to,
  children,
  className = "",
  onClick
}: LinkPrimaryArrowProps) {
  return (
    <Link to={to} onClick={onClick}>
      <PrimaryArrowButton className={className}>{children}</PrimaryArrowButton>
    </Link>
  );
}
